import React from 'react';

import PropTypes from 'prop-types';
import FaChevronLeft from 'react-icons/lib/fa/chevron-left';

import {
    FormError,
} from 'wanderu-component-form';
import A from 'wanderu-component-react-router-link';
import SocialButtons from 'wanderu-component-social-buttons';
import {
    localize,
} from 'wanderu-i18n';

import baseAppConfig from '../../config/baseApp.locales';
import ResetPasswordForm from './ResetPasswordForm/ResetPasswordForm';

import styles from './ResetPassword.scss';

function ResetPassword(props) {
    const {
        className,
        email,
        error,
        loading,
        success,
        onFacebookClick,
        onGoogleClick,
        onResetPassword,
        reset,
        t,
    } = props;

    function _reset(e) {
        reset();
    }

    function _renderLogInWithThirdParty() {
        return (
            <div className={`${styles.container} ${className}`}>
                <div className={styles.formSubtitle}>
                    {t('reset-password-third-party-account-exists')}
                </div>
                <SocialButtons
                    onFacebookClick={onFacebookClick}
                    onGoogleClick={onGoogleClick}
                />
            </div>
        );
    }

    function _renderRateExceededError() {
        return (
            <FormError>
                {t('reset-password-rate-limit-error')}
            </FormError>
        );
    }

    function _renderEmailForm() {
        const hasError = !!error;
        const rateLimitExceeded = error && error.name === 'LimitExceededError';

        return (
            <div className={`${styles.container} ${className || ''}`}>
                <div className={styles.formSubtitle}>
                    {t('password-reset-instructions')}
                </div>
                {rateLimitExceeded && _renderRateExceededError()}
                <ResetPasswordForm
                    email={email}
                    hasError={hasError}
                    loading={loading}
                    onResetPassword={onResetPassword}
                    success={success}
                />
                <A
                    className={styles.backArrow}
                    href="/account/login"
                    queries={{ email }}
                >
                    <FaChevronLeft />
                </A>
            </div>
        );
    }

    function _renderSubmittedMessage() {
        return (
            <div className={`${styles.container} ${className}`}>
                <div className={styles.subtitle}>
                    {t('email-link-message')}
                </div>
                <div className={styles.hr} />
                <div className={styles.subtitle}>
                    {t('email-missing', {
                        goBackLink: (
                            <span
                                className={styles.fauxLink}
                                key="goBackLink"
                                onClick={_reset}
                                role="button"
                            >
                                {t('go-back-link')}
                            </span>
                        ),
                    })}
                </div>
            </div>
        );
    }

    const useThirdPartyLogin = error && error.name === 'LoginFailedUseThirdPartyError';

    if (useThirdPartyLogin) {
        return _renderLogInWithThirdParty();
    }

    const unknownErrorOccurred = error && error.name === 'UserNotFoundException';

    if (success || unknownErrorOccurred) {
        return _renderSubmittedMessage();
    }

    return _renderEmailForm();
}

ResetPassword.propTypes = {
    className: PropTypes.string,
    email: PropTypes.string,
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    success: PropTypes.bool.isRequired,
    onFacebookClick: PropTypes.func.isRequired,
    onGoogleClick: PropTypes.func.isRequired,
    onResetPassword: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

ResetPassword.defaultProps = {
    email: '',
    loading: false,
    success: false,
};

export { ResetPassword };
export default localize(ResetPassword, baseAppConfig.namespace);
